import React from 'react'

export const PrecioNight = () => {
  return (
    <div className="flex flex-column flex-wrap" style={{
        backgroundColor: '#FFF',
        color: '#16213D',
        width: '98%',
        marginLeft: '1%',
        marginTop: '1%',
    }}>
      <div className="flex flex-column" style={{            
          margin: '20px',            
          justifyContent: 'center',
          alignItems: 'center',
      }}>          
        <h1> MENU ENJOY </h1>
      </div>

      <div className="flex flex-column flex-wrap">
        <span style={{
            fontSize: '20px',
          }}>Noches, domingos y festivos.</span>
        <div className="flex flex-row justify-content-center" style={{
        }}> 
          <div className="flex flex-column m-2" style={{
              backgroundColor: '#16213D',
              borderRadius: '75px',
              height: '150px',
              width: '150px',
            }}>
              <div className="flex" style={{
                justifyContent: 'center',
                marginTop: '35px',
                width: '100%',
                fontSize: '25px',
                fontWeight: 'bold',
                color: '#FFF',
              }}>
                <span>10.90 €</span>                
              </div>
              <div className="flex" style={{
                marginTop: '25px',
                justifyContent: 'center',
                width: '100%',
                fontSize: '25px',
                color: '#FFF',
              }}>
                <span>Infantil</span>                
              </div>
          </div>
          <div className="flex flex-column m-2" style={{
              backgroundColor: '#16213D',
              borderRadius: '75px',
              height: '150px',
              width: '150px',
            }}>
              <div className="flex" style={{
                justifyContent: 'center',
                marginTop: '35px',
                width: '100%',
                fontSize: '25px',
                fontWeight: 'bold',
                color: '#FFF',
              }}>
                <span>21.50 €</span>                
              </div>
              <div className="flex" style={{
                marginTop: '25px',                  
                width: '100%',
                fontSize: '25px',
                color: '#FFF',
                justifyContent: 'center',
              }}>
                <span>Adultos</span>                
              </div>
          </div>
        </div>
        <span style={{
            fontSize: '20px',
          }}>Sabados.</span>
        <div className="flex flex-row justify-content-center" style={{
        }}> 
          <div className="flex flex-column m-2" style={{
              backgroundColor: '#16213D',
              borderRadius: '75px',
              height: '150px',
              width: '150px',
            }}>
              <div className="flex" style={{
                justifyContent: 'center',
                marginTop: '35px',
                width: '100%',
                fontSize: '25px',
                fontWeight: 'bold',
                color: '#FFF',
              }}>
                <span>10.90 €</span>                
              </div>
              <div className="flex" style={{
                marginTop: '25px',
                justifyContent: 'center',
                width: '100%',
                fontSize: '25px',
                color: '#FFF',
              }}>
                <span>Infantil</span>                
              </div>
          </div>
          <div className="flex flex-column m-2" style={{
              backgroundColor: '#16213D',
              borderRadius: '75px',
              height: '150px',
              width: '150px',
            }}>
              <div className="flex" style={{
                justifyContent: 'center',
                marginTop: '35px',
                width: '100%',
                fontSize: '25px',
                fontWeight: 'bold',
                color: '#FFF',
              }}>
                <span>23.90 €</span>                
              </div>
              <div className="flex" style={{
                marginTop: '25px',                  
                width: '100%',
                fontSize: '25px',
                color: '#FFF',
                justifyContent: 'center',
              }}>
                <span>Adultos</span>                
              </div>
          </div>
        </div>        
        <div className="flex flex-column m-2" style={{
          justifyContent: 'center',
          alignItems: 'center',
        }}>
          <span>
            Los niños y niñas menores de 4 años no pagarán.               
          </span>
          <span>
            Los niños entre 4 años a 9 años deberán abonar el menú infantil. 
          </span>
        </div>
        <div className="flex flex-row m-2" style={{
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: '#16213D',
          color: '#FFF',
        }}>
          <div className='flex flex-column' style={{
            width: '80%',
            justifyContent: 'center',
            alignItems: 'center',
          }}>
            <span>
              Pide sólo lo que vayas a comer.
            </span>
            <span>
              Por Cada plato no consumido, habrá una penalización de:
            </span>
          </div>
          <span style={{
            width: '20%',
            fontSize: '40px',
            fontWeight: 'bold',
          }}>
            2 €
          </span>
        </div> 
        <div className="flex" style={{
          fontSize: '12px',
        }}>
        <span style={{
          justifyContent:'center',
          alignItems: 'center',
          alignContent: 'center',
          marginBottom: '10px',
        }}>La elección del MENÚ ENJOY es válida solo para todos los comensales de la mesa. No
incluye bebida ni postre. Es obligatorio un pedido mínimo de 1 bebida por persona
Cada persona puede pedir un máximo de 5 platos cada ronda, sin limite de rondas. El
MENÚ ENJOY es una oportunidad para disfrutar de más especialidades y comer hasta
saciarse sin desperdiciar comida. El orden de servicio de los platos varía según los
tiempos de preparación de cada uno.
        </span>
        </div>     
      </div>
    </div>
  )
}
